import React from 'react'
import Homepage from '../components/Homepage'

export default class Index extends React.Component {
  render() {
    return (
      <div>
        <Homepage />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js